export default "__VITE_ASSET__mGtY5g3c__"